import { Helmet } from "react-helmet";
import {
  DEFAULT_OG_DESCRIPTION,
  DEFAULT_OG_IMAGE,
  DEFAULT_OG_TITLE,
  DEFAULT_TWITTER_DESCRIPTION,
  toAbsoluteUrl,
} from "./seoConstants";

/**
 * Open Graph and Twitter Card meta tags for social link previews.
 * All image and URL values are resolved to absolute URLs for crawlers.
 */
const SocialMetaTags = ({
  title = DEFAULT_OG_TITLE,
  description = DEFAULT_OG_DESCRIPTION,
  image = DEFAULT_OG_IMAGE,
  url,
  type = "website",
  twitterDescription = DEFAULT_TWITTER_DESCRIPTION,
}) => {
  const absoluteImage = toAbsoluteUrl(image);
  const absoluteUrl = url ? toAbsoluteUrl(url) : undefined;

  return (
    <Helmet>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImage} />
      {absoluteUrl && <meta property="og:url" content={absoluteUrl} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="TINT" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="twitter:image" content={absoluteImage} />
    </Helmet>
  );
};

export default SocialMetaTags;

export { DEFAULT_OG_IMAGE } from "./seoConstants";
